import { Box, Card, Divider, Typography } from "@mui/material";
import { formatDate, formatToINR } from "../../../utils";

const CancellationChargesInfo = ({ data }: any) => {
  return (
    <>
      {data && Object?.entries(data || {})?.map(([travellerType, charges]: any) => (
        <Card key={travellerType} sx={{ p: '16px', borderRadius: '8px', mb: '20px' }}>
          <Box display='flex' justifyContent='space-between' mb='15px'>
            <Typography variant="caption" fontWeight={600} color="gray">CANCEL BETWEEN</Typography>
            <Typography variant="caption" fontWeight={600} color="gray">CHARGES ({travellerType ?? 'ADULT'})</Typography>
          </Box>
          {charges?.map((item: any, index: number) => (
            <>
              <Box key={index} display='flex' justifyContent='space-between'>
                <Typography variant="body2">
                  {index === 0 ? `From now` : formatDate(item?.start)} - {formatDate(item?.end)}
                </Typography>
                <Typography variant="body2">{formatToINR(item?.totalCharges)}</Typography>
              </Box>
              {index !== charges?.length - 1 && (
                <Divider sx={{ borderColor: "#DEE2E1", my: '15px' }} />
              )}
            </>
          ))}
        </Card>
      ))}
    </>
  )
}

export default CancellationChargesInfo;